import { makeActionCreator } from '../../helpers';
import { DraftToolbarActionTypes } from '../types';

const expandView = makeActionCreator(DraftToolbarActionTypes.expandView);
const normalView = makeActionCreator(DraftToolbarActionTypes.normalView);

export default {
  expandView,
  normalView,
};
